import MsUI from '@meishi/shared'
import dayjs from 'dayjs'
import dayjsZhCn from 'dayjs/locale/zh-cn'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/axios'

import './styles/index.scss'

dayjs.locale(dayjsZhCn)

const app = createApp(App)
app.use(ElementPlus, { locale: zhCn })
  .use(MsUI)
  .use(router)
  .use(store)
  .mount('#app')
